import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import Button from "../../../Components/Button";

const HELPER_OPTIONS = [
    { value: "0", label: "Not Allowed (0)" },
    { value: "1", label: "1 Helper" },
    { value: "2", label: "2 Helpers" },
    { value: "3", label: "3 Helpers" },
    { value: "4", label: "4 Helpers" },
    { value: "5", label: "5 Helpers" },
    { value: "6", label: "6 Helpers" },
    { value: "7", label: "7 Helpers" },
    { value: "8", label: "8 Helpers" },
    { value: "9", label: "9 Helpers" },
    { value: "10", label: "10 Helpers" },
];

const VehicleTypeForm = ({
    register,
    handleSubmit,
    errors,
    control,
    onSubmit,
    isLoading,
    isEdit = false,
    preview,
    handleImageChange,
    isHelperRequired,
    helperCount,
    setValue,
    watch,
}) => {
    const helperInvalid = isHelperRequired && (!helperCount || Number(helperCount) === 0);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="pform-card">
                <div className="pform-card__head">
                    <span className="pform-card__step">1</span>
                    <div>
                        <h2 className="pform-card__title">Vehicle Image</h2>
                        <p className="pform-card__desc">Icon shown when users select this vehicle type</p>
                    </div>
                </div>

                <div
                    className={`pform-image-upload${preview ? " pform-image-upload--has-preview" : ""}`}
                    onClick={() => document.getElementById("vehicle-img-input").click()}
                >
                    {preview ? (
                        <>
                            <img src={preview} alt="Vehicle preview" />
                            <div className="pform-image-upload__overlay">
                                <i className="fas fa-camera me-2" />
                                Change Image
                            </div>
                        </>
                    ) : (
                        <div className="pform-image-upload__placeholder">
                            <div className="pform-image-upload__icon">
                                <i className="fas fa-truck" />
                            </div>
                            <span className="pform-image-upload__text">Upload Vehicle Image</span>
                            <span className="pform-image-upload__hint">Recommended: 600×400px (JPG, PNG)</span>
                        </div>
                    )}
                    <input
                        type="file"
                        id="vehicle-img-input"
                        hidden
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                </div>
            </div>

            <div className="pform-card">
                <div className="pform-card__head">
                    <span className="pform-card__step">2</span>
                    <div>
                        <h2 className="pform-card__title">Type Details</h2>
                        <p className="pform-card__desc">Name, pricing, weight capacity, and availability</p>
                    </div>
                </div>

                <div className="pform-field">
                    <label className="cms-field-label">
                        Type Name <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        className={`cms-input ${errors.name ? "is-invalid" : ""}`}
                        placeholder="e.g. Cargo Van, Pickup Truck"
                        {...register("name", {
                            onChange: (e) => {
                                if (e.target.value.trimStart() !== e.target.value) {
                                    e.target.value = e.target.value.trimStart();
                                }
                            }
                        })}
                    />
                    {errors.name && <span className="cms-field-error">{errors.name.message}</span>}
                </div>

                <div className="pform-field-row">
                    <div className="pform-field">
                        <label className="cms-field-label">
                            Type Cost ($) <span className="text-danger">*</span>
                        </label>
                        <input
                            type="number"
                            className={`cms-input ${errors.cost ? "is-invalid" : ""}`}
                            placeholder="Base cost"
                            {...register("cost")}
                        />
                        {errors.cost && <span className="cms-field-error">{errors.cost.message}</span>}
                    </div>
                    <div className="pform-field">
                        <label className="cms-field-label">
                            Weight Capacity (lbs) <span className="text-danger">*</span>
                        </label>
                        <input
                            type="number"
                            className={`cms-input ${errors.weightLimit ? "is-invalid" : ""}`}
                            placeholder="e.g. 150"
                            {...register("weightLimit")}
                        />
                        {errors.weightLimit && (
                            <span className="cms-field-error">{errors.weightLimit.message}</span>
                        )}
                    </div>
                </div>

                <div className="pform-field">
                    <label className="cms-field-label">
                        Status <span className="text-danger">*</span>
                    </label>
                    <Controller
                        name="status"
                        control={control}
                        render={({ field }) => (
                            <select className={`cms-input ${errors.status ? "is-invalid" : ""}`} {...field}>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </select>
                        )}
                    />
                </div>
            </div>

            <div className="pform-card">
                <div className="pform-card__head">
                    <span className="pform-card__step">3</span>
                    <div>
                        <h2 className="pform-card__title">Lugging & Helper Setup</h2>
                        <p className="pform-card__desc">Configure extra labor support for this vehicle</p>
                    </div>
                </div>

                <div className={`pform-helper-row ${isHelperRequired ? "is-on" : ""}`}>
                    <div className="pform-helper-row__text">
                        <strong>Enable Helper Service</strong>
                        <span>Does this vehicle support extra labor?</span>
                    </div>
                    <div className="pform-helper-row__controls">
                        <span className={`pform-helper-badge ${isHelperRequired ? "pform-helper-badge--on" : "pform-helper-badge--off"}`}>
                            {isHelperRequired ? "ON" : "OFF"}
                        </span>
                        <label className="pform-switch">
                            <input
                                type="checkbox"
                                checked={isHelperRequired || false}
                                onChange={(e) => {
                                    const enabled = e.target.checked;
                                    setValue("isHelperRequired", enabled);
                                    if (enabled && (!watch("helperCount") || watch("helperCount") == 0)) {
                                        setValue("helperCount", 1);
                                    }
                                    if (!enabled) {
                                        setValue("helperCount", 0);
                                    }
                                }}
                            />
                            <span className="pform-switch__slider" />
                        </label>
                    </div>
                </div>

                {isHelperRequired && (
                    <div className="pform-field">
                        <label className="cms-field-label">
                            Max Helpers Count <span className="text-danger">*</span>
                        </label>
                        <select
                            className={`cms-input ${helperInvalid ? "is-invalid" : ""}`}
                            {...register("helperCount", { required: isHelperRequired })}
                        >
                            {HELPER_OPTIONS.filter((opt) => opt.value !== "0").map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </select>
                        {helperInvalid && (
                            <span className="cms-field-error">Please select at least 1 helper</span>
                        )}
                        <p className="pform-field-hint">
                            Maximum number of assistants that can accompany this vehicle.
                        </p>
                    </div>
                )}
            </div>

            <div className="pform-footer">
                <Link to="/vehicle-type-management" className="cms-btn-cancel">
                    Cancel
                </Link>
                <Button className="cms-btn-save" type="submit" loading={isLoading}>
                    {isEdit ? "Update Vehicle Type" : "Save Vehicle Type"}
                </Button>
            </div>
        </form>
    );
};

export default VehicleTypeForm;
